<script lang="ts">
	export let className = 'size-5';
</script>

<!--
	Source: Custom
	Copyright: IONOS
	Origin: iOS Share icon for PWA instructions
-->

<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentColor" class={className}>
  <path d="M12 2.5L8.5 6L10 7.5L11 6.5V13H13V6.5L14 7.5L15.5 6L12 2.5ZM6 9V19C6 20.1 6.9 21 8 21H16C17.1 21 18 20.1 18 19V9H16V19H8V9H6Z"/>
</svg>